export enum SizeTokenType {
  Xs = 'size-xs',
  Sm = 'size-sm',
  Md = 'size-md',
  Lg = 'size-lg',
  Xl = 'size-xl',
  Xl2 = 'size-2xl',
  Xl3 = 'size-3xl',
  Xl4 = 'size-4xl',
  Row = 'size-row',
  Target = 'size-target',
  Touch = 'size-touch',
}
